import { render, staticRenderFns } from "./AmericanImport.vue?vue&type=template&id=20d2f6ca&"
import script from "./AmericanImport.vue?vue&type=script&lang=js&"
export * from "./AmericanImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports